import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import ThumbnailSelectable from 'components/ThumbnailSelectable'

import styles from './ThumbnailsSelectable.module.scss'

export default class ThumbnailsSelectable extends React.Component {
  static propTypes = {
    active: PropTypes.string,
    className: PropTypes.string,
    //thumbnails: PropTypes.array,
    thumbnails: PropTypes.object,
    onThumbnailSelect: PropTypes.func,
  }

  constructor(props) {
    super(props)

    this.state = {
      active: props.active || '',
    }
  }

  handleClick = (imageId, imageRef, imageURL) => {
    const { onThumbnailSelect } = this.props

    this.setState({ active: imageRef })

    if (onThumbnailSelect) onThumbnailSelect(imageId, imageRef, imageURL)
  }

  render() {
    const { className, thumbnails } = this.props
    const { active } = this.state

    return (
      <div
        uk-grid="true"
        className={classNames('ThumbnailsSelectable', 'uk-grid-small', styles.this, className)}>
        {Object.keys(thumbnails).map((thumbnailId) => {
          const thumbnail = thumbnails[thumbnailId]

          if (!thumbnail.imageRef) return null

          return (
            <div key={thumbnail.imageRef}>
              <ThumbnailSelectable
                active={active === thumbnail.imageRef}
                //image={thumbnail.imageUrl}
                image={thumbnail.imageRef}
                onClick={() => this.handleClick(thumbnailId, thumbnail.imageRef, thumbnail.imageUrl)}
              />
            </div>
          )
        })}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ThumbnailsSelectable/ThumbnailsSelectable.js